import {useMemo} from 'react';
import {AiResponsePartComponent} from './MessageParts/AiResponsePartComponent';
import {ChannelMenuPartComponent} from './MessageParts/ChannelMenuPartComponent';
import {
  MessagePartComponentContext,
  MessagePartComponentRegistry,
} from './MessagePartComponentContext';

export const DefaultMessagePartComponentsMap: MessagePartComponentRegistry = {
  ai_response: AiResponsePartComponent,
  channel_menu: ChannelMenuPartComponent,
};

export function MessagePartComponentProvider({
  value = {},
  children,
}: {
  value?: MessagePartComponentRegistry;
  children: React.ReactNode;
}) {
  const components = useMemo(
    () => ({...DefaultMessagePartComponentsMap, ...value}),
    [value],
  );

  return (
    <MessagePartComponentContext.Provider value={components}>
      {children}
    </MessagePartComponentContext.Provider>
  );
}
